export function replaceHiddenInputValues() {
    const marketoSourceCampaign =
        document.querySelector("body")?.getAttribute("data-source-campaign") ?? "";

    const hiddenInputs = document.querySelectorAll<HTMLInputElement>(
        'input[type="hidden"][value="SOURCECAMPAIGN"]'
    );

    hiddenInputs.forEach((input) => {
        input.value = marketoSourceCampaign;
    });

    const whitepaperAssetId =
        document.querySelector("body")?.getAttribute("data-whitepaper-assetId") ?? "";

    const hiddenInputsAssetId = document.querySelectorAll<HTMLInputElement>(
        'input[type="hidden"][value="WhitePaperAssetId"]'
    );

    hiddenInputsAssetId.forEach((input) => {
        input.value = whitepaperAssetId;
    });
}

